import { Link } from "@tiptap/extension-link";

// v3 LinkOptions has required fields (validate, isAllowedUri, …) beyond what
// this override sets — configure() merges these over the parent defaults,
// where the old addOptions override replaced them wholesale.
export const SlackLink = Link.configure({
  autolink: true,
  linkOnPaste: true,
  HTMLAttributes: {
    rel: "noopener noreferrer",
    // Open a separate tab.
    target: null,
    class: "rte-link-class",
  },
  protocols: [],
  openOnClick: false,
});
